import React from 'react';
import { withNavigate } from '../util/withNavigate';
import PuffLoader from 'react-spinners/PuffLoader';

import { connect } from 'react-redux';
import Cookies from 'js-cookie';

import bdAuth from '../network/bdAuth';
import bdReq from '../network/bdReq';

import { getDeviceId } from '../util/device';

import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { generateDeviceId, storeHistory, mobileDeviceId } from '../store/actions/appActions';

import { fetchDevice, updateDevice } from '../store/actions/deviceActions';
import { fetchMobileStatus, fetchMobileQueue } from '../store/actions/mobileActions';
import { fetchUser, clearUser } from '../store/actions/userActions';
import { fireAnalytics, VERSION } from './utils';
import {
  fetchFeaturedPlaylist,
  fetchPortraitFeaturedPlaylist,
  fetchUserPlaylists,
  fetchHomePlaylist,
  fetchMyPlaylist,
  fetchActivePlaylist,
  fetchActivePlaylistSuccess,
  clearFeaturedPlaylist,
  clearUserPlaylists,
  clearActivePlaylist,
} from '../store/actions/playlistActions';
import { set4kQuality, setMute, setQR, setShowArtworkDetails, setSwitchArtwork, setShowLogo, setMatchContent, setFillScreen, setRandomise } from '../store/actions/settingActions';
import { fetchSubscription, clearSubscription } from '../store/actions/subscriptionActions';

export class SplashScreen extends React.Component {
  async componentDidMount() {
    window.isUSB = false;
    //const result = await this.checkOnlineStatus();
    //this.enableDebugMode();
    //if (!result) this.goToPage('/offline');
    //this.changeLogoImage();
    // console.log("This is new design SCAP App");
    // this.checkStorage();
    this.getPlatformInformation();
    //this.loadData();
  }

  goToPage = (pageLink) => {
    const { navigate } = this.props;
    navigate(pageLink);
  };

  async checkOnlineStatus() {
    try {
      const online = await fetch('assets/img/blackdove-logo-2020.png');
      return online.status >= 200 && online.status < 300; // either true or false
    } catch (err) {
      return false; // definitely offline
    }
  }

  changeLogoImage() {
    const successCb = function () {
      console.log('Upgrading logo image is successful');
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      console.log(` Error Code [${errorCode}]: ${errorText}`);
    };

    const options = {
      uri: 'https://assets.blackdove.com/images/Plogo.png'
    };

    // Check the screen orientation
    // and set the logo image accordingly
    console.log('Screen Orientation:' + screen?.orientation?.type);
    // if (screen?.orientation?.type?.toLowerCase()?.includes('portrait')) {
    //   options.uri = 'https://assets.blackdove.com/images/Plogo.png';
    // }
    console.log('Logo Image URL:' + options.uri);
    // console.log("Changing Logo Image");
    const storage = new Storage();
    storage.changeLogoImage(successCb, failureCb, options);
  }

  enableDebugMode() {
    const configuration = new Configuration();
    const options = {};
    options.enabled = true; //enabling debug mode
    configuration.debug(
      function successCb() {
        console.log("Succeeded to enable the debug mode");
      },
      function failureCb() {
        console.log("Failed to enable the debug mode");
      },
      options
    );
  }

  checkStorage() {
    // console.log("Checking Internal Storage");
    const that = this;
    const successCb = function (cbObject) {
      const { free } = cbObject;
      if (free > 200000) {
        // console.log("Space Available");
        that.getPlatformInformation();
      } else {
        that.clearInternalStorage();
      }
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      // console.log(" Error Code [" + errorCode + "]: " + errorText);
    };

    const storage = new Storage();
    storage.getStorageInfo(successCb, failureCb);
  }

  clearInternalStorage() {
    const that = this;
    const successCb = function (cbObject) {
      // console.log("Removed all files Internal");
      that.getPlatformInformation();
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      // console.log(" Error Code [" + errorCode + "]: " + errorText);
    };

    const options = {
      device: 'internal' // This will remove all the files in the local storage.
    };

    const storage = new Storage();
    storage.removeAll(successCb, failureCb, options);
  }

  getPlatformInformation() {
    const that = this;
    function successCb(cbObject) {
      console.log('[Platform Info] : ' + JSON.stringify(cbObject));
      localStorage.setItem('DeviceID', cbObject.serialNumber);
      that.loadData();
    }

    function failureCb(cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;

      console.log('Error Code [' + errorCode + ']: ' + errorText);
      that.loadData();
    }

    const deviceInfo = new DeviceInfo();
    deviceInfo.getPlatformInfo(successCb, failureCb);
  }

  async loadData() {
    try {
      // Initialize app
      await this.initializeApp();
      
      // Fetch device and handle initial setup
      const deviceResult = await this.fetchAndValidateDevice();
      if (!deviceResult) return; // Error occurred, already handled
      
      if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
        await this.handleSuccessfulDeviceSetup(deviceResult);
      } else {
        await this.handleDevicePairingRequired();
      }
      
    } catch (e) {
      console.error('Error in loadData:', e);
      this.goToPage('/error');
    }
  }
  
  // Initialize app with device ID and analytics
  async initializeApp() {
    const deviceId = getDeviceId();
    fireAnalytics('Launch', 'Starting App', deviceId);
    
    // Set first launch timestamp if not exists
    if (!localStorage.getItem('firstLaunchedAt')) {
      localStorage.setItem('firstLaunchedAt', new Date());
    }
    
    await this.props.storeHistory(this.props.history);
    
    if (!this.props.app.SCAPDeviceId) {
      this.props.generateDeviceId(deviceId);
    }
    
    localStorage.setItem('DownloadInfo', null);
  }
  
  // Fetch device and validate response
  async fetchAndValidateDevice() {
    const deviceResult = await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    
    if (deviceResult.errors === 'Error') {
      setTimeout(() => this.goToPage('/error'), 10);
      return null;
    }
    
    return deviceResult;
  }
  
  // Handle successful device setup flow
  async handleSuccessfulDeviceSetup(deviceResult) {
    // Authenticate user first so subsequent API calls have auth token
    await this.authenticateUser(deviceResult.payload);

    // Update device orientation and content matching
    await this.updateDeviceSettings();

    // Fetch mobile status and update app settings
    const status = await this.fetchMobileStatusAndUpdateSettings();

    // Fetch all required data
    await this.fetchAllRequiredData();
    
    // Determine target playlist and navigate (uses queue endpoint for matchContent filtering)
    const targetPlaylistId = await this.determineTargetPlaylist(status);

    setTimeout(() => {
      this.goToPage(`/playlist/${targetPlaylistId}`);
    }, 10);
  }
  
  // Update device orientation and content settings
  async updateDeviceSettings() {
    const orientation = screen.orientation.type === "landscape-primary" ? 'landscape' : 'portrait';
    const deviceId = this.props.device.data.id;
    
    const orientationUpdate = await this.props.updateDevice(deviceId, 'orientation', orientation);
    
    if (orientationUpdate.success) {
      await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    }
  }
  
  // Fetch mobile status and update app settings
  async fetchMobileStatusAndUpdateSettings() {
    const status = await this.props.fetchMobileStatus(this.props.app.SCAPDeviceId);
    const { payload } = status;
    
    // Update all settings from status payload
    const settingsUpdates = [
      ['updateMatchContent', payload.matchContent],
      ['updateQuality', payload.highQuality],
      ['updateMute', payload.mute],
      ['updateQR', payload.qr],
      ['updateShowArtDetails', payload.details],
      ['updateShowLogo', payload.logo],
      ['updateFillScreen', payload.fillScreen],
      ['updateRandomise', payload.fillScreen] // Note: Change later
    ];
    
    settingsUpdates.forEach(([method, value]) => {
      this.props[method](value);
    });
    
    return status;
  }
  
  // Authenticate user with email login
  async authenticateUser({ email: emailId, userId }) {
    await this.props.mobileDeviceId(userId);
    
    // Email authentication
    const response = await bdReq.post('/emailLogin', { emailId });
    if (response.success) {
      bdAuth._storeToken(response.body);
    }
  }
  
  // Fetch all required data with error handling
  async fetchAllRequiredData() {
    const fetchOperations = [
      { name: 'fetchUser', method: this.props.fetchUser },
      { name: 'fetchSubscription', method: this.props.fetchSubscription },
      { name: 'fetchFeaturedPlaylist', method: this.props.fetchFeaturedPlaylist },
      { name: 'fetchPortraitFeaturedPlaylist', method: this.props.fetchPortraitFeaturedPlaylist },
      { name: 'fetchHomePlaylist', method: this.props.fetchHomePlaylist },
      { name: 'fetchUserPlaylists', method: this.props.fetchUserPlaylists }
    ];
    
    for (const { name, method } of fetchOperations) {
      const result = await method();
      if (result.errors === 'Error') {
        console.error(`Error in ${name}:`, result);
        setTimeout(() => this.goToPage('/error'), 10);
        throw new Error(`Failed to fetch ${name}`);
      }
    }
  }
  
  // Determine target playlist based on status and orientation
  async determineTargetPlaylist(status) {
    const defaultPlaylistIds = {
      'landscape-primary': 'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx',
      'portrait': 'b1f908bb-9722-4e70-ac5c-653ad45ee3ea'
    };

    const defaultPlaylistId = defaultPlaylistIds[screen.orientation.type] || defaultPlaylistIds['portrait'];
    const targetPlaylistId = status.payload.playingCollection || defaultPlaylistId;

    // Use the device queue endpoint (filters by matchContent/orientation)
    const queueResult = await this.props.fetchMobileQueue(this.props.app.SCAPDeviceId);

    if (queueResult.errors === 'Error' || queueResult.errors === 'Device Unregistered') {
      // Fallback to unfiltered collection endpoint
      let fetchResult = await this.props.fetchActivePlaylist(targetPlaylistId);

      if (fetchResult.errors === 'No Artworks') {
        fetchResult = await this.props.fetchActivePlaylist(defaultPlaylistId);
      }

      if (fetchResult.errors === 'Error') {
        setTimeout(() => this.goToPage('/error'), 10);
        throw new Error('Failed to fetch active playlist');
      }
    } else if (queueResult.payload?.collection) {
      // Populate activePlaylist Redux state with filtered queue data
      this.props.setActivePlaylist(queueResult.payload.collection);
    }

    return targetPlaylistId;
  }
  
  // Handle device pairing required flow
  async handleDevicePairingRequired() {
    // Clear all stored data
    const clearMethods = [
      'clearFeaturedPlaylist',
      'clearUserPlaylists', 
      'clearActivePlaylist',
      'clearUser',
      'clearSubscription'
    ];
    
    clearMethods.forEach(method => {
      this.props[method]();
    });
    
    // Remove cookies
    ['auth__token', 'artwork_Interval'].forEach(cookie => {
      Cookies.remove(cookie);
    });
    
    setTimeout(() => {
      this.goToPage('/pair');
    }, 10);
  }

  render() {
    return (
      <div className="SplashPage">
        <div className="SplashWrapper">
          <img style={{margin: "25vh"}} className="Logo" src="assets/img/blackdove-logo-2020.png" alt="" />
            <PuffLoader 
              color="white" 
              size={100} />
        </div>
        <div className='appVersion'>{`${VERSION}`}</div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  generateDeviceId: (deviceId) => dispatch(generateDeviceId(deviceId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  updateDevice: (deviceId, updateVal, value) => dispatch(updateDevice(deviceId, updateVal, value)),
  fetchMobileStatus: (deviceId) => dispatch(fetchMobileStatus(deviceId)),
  fetchMobileQueue: (deviceId) => dispatch(fetchMobileQueue(deviceId)),
  storeHistory: (history) => dispatch(storeHistory(history)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchPortraitFeaturedPlaylist: () => dispatch(fetchPortraitFeaturedPlaylist()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchUserPlaylists: () => dispatch(fetchUserPlaylists()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  setActivePlaylist: (collection) => dispatch(fetchActivePlaylistSuccess(collection)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
  updateMute: (val) => dispatch(setMute(val)),
  updateShowLogo: (val) => dispatch(setShowLogo(val)),
  updateShowArtDetails: (val) => dispatch(setShowArtworkDetails(val)),
  updateQR: (val) => dispatch(setQR(val)),
  updateSwitchArtwork: (val) => dispatch(setSwitchArtwork(val)),
  updateQuality: (val) => dispatch(set4kQuality(val)),
  updateMatchContent: (val) => dispatch(setMatchContent(val)),
  updateFillScreen: (val) => dispatch(setFillScreen(val)),
  updateRandomise: (val) => dispatch(setRandomise(val))
});
export default connect((state) => {
  const { app, device, activePlaylist } = state;
  return {
    app,
    device,
    activePlaylist,
  };
}, mapDispatchToProps)(withNavigate(SplashScreen));
